export const claimsCount = '170+'
